exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".progress {\r\n  height: 3rem;\r\n  border-radius: 0;\r\n  position: relative;\r\n}\r\n\r\n.progress-bar {\r\n  position: absolute;\r\n}\r\n\r\n.hours-list {\r\n  font-size: .625rem;\r\n  width: 1rem;\r\n  text-align: center;\r\n  position: absolute;\r\n}\r\n\r\n.hours-list:first-of-type {\r\n  margin-left: .3rem;\r\n}\r\n\r\n.hours-list-container {\r\n  position: relative;\r\n  height: 1rem;\r\n  left: -.7rem;\r\n}\r\n\r\n.hours-range-item {\r\n  height: 3rem;\r\n}\r\n\r\nbutton {\r\n  position: absolute;\r\n  bottom: 0;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/ecv-project/time-tracker/time-tracker-work-day/time-tracker-work-day.component.css
// module id = ../../../../../src/app/ecv-project/time-tracker/time-tracker-work-day/time-tracker-work-day.component.css
// module chunks = main